import {FC, useEffect, useState} from 'react'
import {Spinner, ProgressBar} from 'react-bootstrap'

type CGESimulationLoadingProps = {
  method: 'johansen' | 'gragg'
}

// Rough expected solve durations, per the solver tooltips in CGEShockForm.
// Johansen solves in milliseconds, gragg is a non-linear multi-step solve
// (~15-60s). There's no real progress channel from the backend (single
// request/response), so this is a timer-based estimate, capped short of
// 100% until the response actually arrives.
const EXPECTED_DURATION_MS: Record<'johansen' | 'gragg', number> = {
  johansen: 1500,
  gragg: 35000,
}
const MAX_ESTIMATED_PCT = 95

const CGESimulationLoading: FC<CGESimulationLoadingProps> = ({method}) => {
  const [pct, setPct] = useState(0)

  useEffect(() => {
    setPct(0)
    const start = performance.now()
    const duration = EXPECTED_DURATION_MS[method]
    const interval = setInterval(() => {
      const elapsed = performance.now() - start
      setPct(Math.min(MAX_ESTIMATED_PCT, Math.round((elapsed / duration) * MAX_ESTIMATED_PCT)))
    }, 150)
    return () => clearInterval(interval)
  }, [method])

  return (
    <div className='d-flex flex-column align-items-center justify-content-center gap-3 py-10'>
      <div className='d-flex align-items-center gap-3'>
        <Spinner animation='border' size='sm' variant='primary' />
        <span className='text-gray-700 fw-semibold'>Running simulation... {pct}%</span>
      </div>
      <ProgressBar now={pct} style={{width: 240}} variant='primary' animated />
    </div>
  )
}

export {CGESimulationLoading}
